exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vdatetime {\r\n  flex: 1;\n}\n.vdatetime-fade-enter-active,\r\n.vdatetime-fade-leave-active {\r\n  transition: opacity .4s;\n}\n.vdatetime-fade-enter,\r\n.vdatetime-fade-leave-to {\r\n  opacity: 0;\n}\n.vdatetime-popup {\r\n    z-index: 1041;\n}\n.vdatetime-calendar__navigation--previous{\r\n    z-index: 100;\n}\r\n", ""]);

// exports
